import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const vesselCrewRepository = AiseaApiFactory.get("enterpriseManningVesselCrew");

const EnterpriseManningVesselCrewService = (() => {
  const fetchById = async id => {
    const payload = {
      details: [
        "MANNING_VESSEL_CREW_ROLE",
        "MANNING_VESSEL_CREW_UPDATE_HISTORY",
      ],
    };
    const res = await vesselCrewRepository.show(id, payload);
    if (!res || !res.status) throw res;
    return res.data;
  };

  const updateRemark = async (id, data) => {
    const res = await vesselCrewRepository.updateRemark(id, data);
    if (!res || !res.status) throw res;
    return res.data;
  };

  return { fetchById, updateRemark };
})();

export default EnterpriseManningVesselCrewService;
